<script>
  import { onMount } from 'svelte';
  import { carregaPromocao, editaPromocao, deletaPromocao, procuraProdutos } from '../../actions/database.js';

  import Page from "../../containers/Page/Page.svelte";
  import Modal from "../../components/Modal/Modal.svelte";

  export let params = {}

  let promocao = {
    produtos: []
  };
  let alert;
  let error;
  let searchResult = [];

  onMount(async () => {
    promocao = await carregaPromocao(params.id);
  });

  const handleEdit = async () => {
    alert = "Atualizando...";
    try {
      await editaPromocao(promocao);
      alert = "Categoria atualizada!";
    } catch (error) {
      alert = `Erro ao atualizar a categoria: ${error}`;
    }
  }

  const handleSearch = async (nome) => {
    if (nome.length < 3) {
      searchResult = []
      return false;
    }
    try {
      searchResult = await procuraProdutos(nome);
    } catch (error) {
      console.log(error);
    }
  }

  const handleDelete = async () => {
    const ask = confirm(
      `Você tem certeza que quer deletar a promoção?`
    );

    if (!ask) return false;

    alert = "Deletando...";
    try {
      await deletaPromocao(promocao);
      alert = "Promoção deletada!";
    } catch (error) {
      alert = `Erro ao atualizar a promocao: ${error}`;
    }
  }

  const handleAdicionaProduto = (nome, id, slug) => {
    promocao.produtos = [
      ...promocao.produtos,
      {
        nome,
        id,
        slug
      }
    ]
  }

  const handleDeletaProduto = i => {
    promocao.produtos.splice(i, 1);
    promocao.produtos = promocao.produtos;
  }

  const close = () => alert = null;
</script>

{#if alert}
  <Modal
    { alert }
    { close }
  />
{/if}

{#if promocao}
  <Page title="Editar Promoção">
    <div class="box">
      <div class="field is-horizontal">
        <div class="content">
          <h3>Dados da promoção:</h3>
        </div>
      </div>
      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Nome</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control is-expanded">
              <input bind:value={promocao.nome} class="input" type="text">
            </p>
          </div>
        </div>
      </div>
      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Ativo</label>
        </div>
        <div class="field-body">
          <div class="field">
            <div class="control is-expanded">
              <div class="select">
                <select bind:value={promocao.ativo}>
                  <option value="nao">Não</option>
                  <option value="sim">Sim</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Descrição</label>
        </div>
        <div class="field-body">
          <div class="field">
            <div class="control">
              <textarea bind:value={promocao.descricao} class="textarea"></textarea>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Produtos</label>
        </div>
        <div class="field-body">
          <div class="field">
            <div class="control">
              {#if promocao.produtos}
                {#each promocao.produtos as item, i}
                  <li class="list-itens">
                    <div class="columns">
                      <div class="column">
                        {item.nome}
                        -
                        <span
                          on:click={() => handleDeletaProduto(i)}
                          class="link"
                        >
                          Remover produto
                        </span>
                      </div>
                    </div>
                  </li>
                {/each}
              {/if}
            </div>
          </div>
        </div>
      </div>
      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Adicionar produto</label>
        </div>
        <div class="field-body">
          <div class="field has-addons">
            <div class="control is-expanded">
              <input
                on:keyup={(event) => handleSearch(event.target.value)}
                class="input"
                type="text"
              />
              <br>
              <br>
              {#if searchResult}
                <ul>
                  <li>
                    {#each searchResult as item}
                        <p class="result-name">
                          {item.nome}
                          -
                          <span
                            class="link"
                            on:click={() => handleAdicionaProduto(item.nome, item.id, item.slug)}
                          >
                            Adicionar produto
                          </span>
                        </p>
                    {/each}
                  </li>
                </ul>
              {/if}
            </div>
          </div>
        </div>
      </div> -->
      <br><br>
      <div class="control has-text-right">
        <button
          on:click={handleDelete}
          class="button is-danger"
        >
          Deletar promoção
        </button>
        <button
          on:click={handleEdit}
          class="button is-primary"
        >
          Editar promoção
        </button>
      </div>
    </div>
  </Page>
{/if}

<style>
  .error.notification {
    padding: 10px;
  }
  .result-name {
    line-height: 39px;
  }
  .list-itens {
    padding: 10px;
  }
  .link {
    color: #3273dc;
    text-decoration: underline;
    cursor: pointer;
  }
</style>